import React from 'react';
import ErrorMessage from './ErrorMessage';
const CustomErrorMessage = (props) => {
    const { children } = props;
    return React.createElement(ErrorMessage, { condition: true, message: children });
};
export default CustomErrorMessage;
